import React, { useCallback, useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import Layout from "./Layout";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

function NewDashboard() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  useEffect(() => {
    closeSidebar();
  }, [closeSidebar, location.pathname]);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebarOpen]);

  return (
    <div className="min-h-screen bg-bgWhite">
      <Navbar onMenuClick={() => setSidebarOpen(true)} />

      {sidebarOpen && (
        <button
          type="button"
          onClick={closeSidebar}
          className="fixed inset-x-0 bottom-0 top-16 z-30 bg-black/40 lg:hidden"
          aria-label="Close navigation menu"
        />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      <main className="min-w-0 pt-16 lg:pl-64">
        <Layout />
      </main>
    </div>
  );
}

export default NewDashboard;
